import styled from "styled-components";

export const PaginationWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;
